import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Quotation from './quotation';
import QuotationDetail from './quotation-detail';
import QuotationUpdate from './quotation-update';
import QuotationPurchase from './quotation-purchase';
import QuotationBought from './bought/quotation-bought';
import BoubyanQuotationBought from './boubyan/quotation-bought';
import QuotationDeleteDialog from './quotation-delete-dialog';
import PurchaseCertificateTemplate from './purchase-certificate-template';
import SellCertificateTemplate from './sell-certificate-template';
import CancellationCertificateTemplate from './cancellation-certificate-template';
import TransferCertificateTemplate from './transfer-certificate-template';
import ApproveQuotationByBranchManager from './quotation-approve-branchmanager';
import AmendQuotationByBranchManager from './quotation-amend-branchmanager';
import PrivateRoute from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';
import {PurchasePrintTemplate} from "app/entities/quotation/purchase-print-template";
import BursaPurchaseCertificateTemplate from "app/entities/quotation/bursa_purchase_certificate_template";
import BursaSellCertificateTemplate from "app/entities/quotation/bursa_sell_certificate_template";
import BursaTransferCertificateTemplate from "app/entities/quotation/bursa_transfer_certificate_template";
import TransactionFormsPurchase from "app/entities/quotation/transaction-forms-purchase";
import TransactionFormsTransfer from "app/entities/quotation/transaction-forms-transfer";
import TransactionFormsSell from "app/entities/quotation/transaction-forms-sell";
import LocalTransactionFormsPurchase from "app/entities/quotation/local-transaction-forms-purchase";
import LocalTransactionFormsTransfer from "app/entities/quotation/local-transaction-forms-transfer";
import LocalTransactionFormsSell from "app/entities/quotation/local-transaction-forms-sell";
import BoubyanLocalTransactionFormsPurchase from "app/entities/quotation/client-docs/boubyan-bank/transaction-forms/local/transaction-forms-purchase";
import BoubyanLocalTransactionFormsTransfer from "app/entities/quotation/client-docs/boubyan-bank/transaction-forms/local/transaction-forms-transfer";
import BoubyanLocalTransactionFormsSell from "app/entities/quotation/client-docs/boubyan-bank/transaction-forms/local/transaction-forms-sell";
import BoubyanTransactionFormsPurchase from "app/entities/quotation/client-docs/boubyan-bank/transaction-forms/international/transaction-forms-purchase";
import BoubyanTransactionFormsTransfer from "app/entities/quotation/client-docs/boubyan-bank/transaction-forms/international/transaction-forms-transfer";
import BoubyanTransactionFormsSell from "app/entities/quotation/client-docs/boubyan-bank/transaction-forms/international/transaction-forms-sell";
import InvoiceTemplate from "app/entities/quotation/invoice/invoice-template";
import {PrintConcat} from 'app/entities/quotation/bought/components/print-concat';
import LocalFormTemplate from "app/entities/quotation/local-form/local-form-template";
import PoaFormTemplate from "app/entities/quotation/poa-form/poa-form-template";

const Routes = ({ match }) => {
  return (
    <>
      <Switch>
        <PrivateRoute exact path={`${match.url}/new`} component={QuotationUpdate} hasAnyAuthorities={[AUTHORITIES.BANK_STAFF]} />
        <PrivateRoute exact path={`${match.url}/purchase/:id`} component={QuotationPurchase} />
        <PrivateRoute
          exact
          path={`${match.url}/bought/:id`}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
          component={QuotationBought}
        />
        <PrivateRoute exact path={`${match.url}/boubyan/bought/:id`} hasAnyAuthorities={[
          AUTHORITIES.ADMIN,
          AUTHORITIES.BANK_STAFF,
          AUTHORITIES.AUDITOR,
          AUTHORITIES.BANK_MANAGER,
          AUTHORITIES.AREA_MANAGER,
          AUTHORITIES.BRANCH_MANAGER,
          AUTHORITIES.CUSTOMER,
          AUTHORITIES.ALSHMOKH_ADMIN,
          AUTHORITIES.ALSHMOKH_USER,
          AUTHORITIES.PURCHASE_APPROVAL,
          AUTHORITIES.SELL_APPROVAL,
        ]} component={BoubyanQuotationBought} />
        <PrivateRoute exact path={`${match.url}/approve-by-branch-manager/:id`} component={ApproveQuotationByBranchManager} />
        <PrivateRoute exact path={`${match.url}/amend-by-branch-manager/:id`} component={AmendQuotationByBranchManager} />
        <PrivateRoute
          exact
          path={`${match.url}/:id/edit`}
          component={QuotationUpdate}
          hasAnyAuthorities={[AUTHORITIES.BANK_STAFF, AUTHORITIES.AUDITOR, AUTHORITIES.BANK_MANAGER, AUTHORITIES.BRANCH_MANAGER]}
        />

        <PrivateRoute exact path={`${match.url}/purchase-print/:id`} component={PurchasePrintTemplate} />

        <PrivateRoute
          exact
          path={`${match.url}/purchase-certificate/:id`}
          component={PurchaseCertificateTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />
        <PrivateRoute
          exact
          path={`${match.url}/sell-certificate/:id`}
          component={SellCertificateTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />
        <PrivateRoute
          exact
          path={`${match.url}/cancellation-certificate/:id`}
          component={CancellationCertificateTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />
        <PrivateRoute
          exact
          path={`${match.url}/bursa-purchase-certificate/:id`}
          component={BursaPurchaseCertificateTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />
        <PrivateRoute
          exact
          path={`${match.url}/bursa-sell-certificate/:id`}
          component={BursaSellCertificateTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />
        <PrivateRoute
          exact
          path={`${match.url}/bursa-transfer-certificate/:id`}
          component={BursaTransferCertificateTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />
        <PrivateRoute
          exact
          path={`${match.url}/transfer-certificate/:id`}
          component={TransferCertificateTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />
        <PrivateRoute
          exact
          path={`${match.url}/transaction-forms-purchase/:id`}
          component={TransactionFormsPurchase}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />
        <PrivateRoute
          exact
          path={`${match.url}/transaction-forms-transfer/:id`}
          component={TransactionFormsTransfer}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />
        <PrivateRoute
          exact
          path={`${match.url}/transaction-forms-sell/:id`}
          component={TransactionFormsSell}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />

        <PrivateRoute
          exact
          path={`${match.url}/local-transaction-forms-purchase/:id`}
          component={LocalTransactionFormsPurchase}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />

        <PrivateRoute
          exact
          path={`${match.url}/local-transaction-forms-transfer/:id`}
          component={LocalTransactionFormsTransfer}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />

        <PrivateRoute
          exact
          path={`${match.url}/local-transaction-forms-sell/:id`}
          component={LocalTransactionFormsSell}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />

        <PrivateRoute
          exact path={`${match.url}/boubyan/transaction-forms-purchase/:id`}
          component={BoubyanTransactionFormsPurchase}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL
          ]}/>

        <PrivateRoute
          exact path={`${match.url}/boubyan/transaction-forms-transfer/:id`}
          component={BoubyanTransactionFormsTransfer}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL
          ]}/>

        <PrivateRoute
          exact path={`${match.url}/boubyan/transaction-forms-sell/:id`}
          component={BoubyanTransactionFormsSell}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL
          ]}/>

        <PrivateRoute
          exact path={`${match.url}/boubyan/local-transaction-forms-purchase/:id`}
          component={BoubyanLocalTransactionFormsPurchase}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL
          ]}/>

        <PrivateRoute
          exact path={`${match.url}/boubyan/local-transaction-forms-transfer/:id`}
          component={BoubyanLocalTransactionFormsTransfer}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL
          ]}/>

        <PrivateRoute
          exact path={`${match.url}/boubyan/local-transaction-forms-sell/:id`}
          component={BoubyanLocalTransactionFormsSell}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.CUSTOMER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL
          ]}/>

        <PrivateRoute
          exact
          path={`${match.url}/invoice-template/:id`}
          component={InvoiceTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />

        <PrivateRoute
          exact
          path={`${match.url}/local-form-template/:id`}
          component={LocalFormTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />

        <PrivateRoute
          exact
          path={`${match.url}/poa-form-template/:id`}
          component={PoaFormTemplate}
          hasAnyAuthorities={[
            AUTHORITIES.ADMIN,
            AUTHORITIES.BANK_STAFF,
            AUTHORITIES.AUDITOR,
            AUTHORITIES.BANK_MANAGER,
            AUTHORITIES.AREA_MANAGER,
            AUTHORITIES.BRANCH_MANAGER,
            AUTHORITIES.ALSHMOKH_ADMIN,
            AUTHORITIES.ALSHMOKH_USER,
            AUTHORITIES.PURCHASE_APPROVAL,
            AUTHORITIES.SELL_APPROVAL,
          ]}
        />

        <PrivateRoute path={`${match.url}/print-concat/:quotationId`} component={PrintConcat} />

        <PrivateRoute exact path={`${match.url}/:id`} component={QuotationDetail} />
        <PrivateRoute path={match.url} component={Quotation} />
      </Switch>
      <PrivateRoute
        exact
        path={`${match.url}/:id/delete`}
        component={QuotationDeleteDialog}
        hasAnyAuthorities={[AUTHORITIES.BANK_STAFF, AUTHORITIES.AUDITOR, AUTHORITIES.BANK_MANAGER, AUTHORITIES.BRANCH_MANAGER]}
      />
    </>
  );
};

export default Routes;
